import { useNavigate, useParams } from 'react-router-dom';
import { 
  ArrowLeft,
  Scissors,
  HardDrives,
  Wallet, 
  ChartBar,
  FileText,
  Circle
} from '@phosphor-icons/react';

const moduleInfo = {
  caixa: { 
    title: 'Caixa', 
    parent: 'Gestão',
    parentPath: '/gestao',
    icon: Wallet,
    color: '#2D6A4F',
    description: 'Torna visível a movimentação financeira básica do dia a dia.'
  },
  producao: { 
    title: 'Produção', 
    parent: 'Gestão',
    parentPath: '/gestao',
    icon: ChartBar,
    color: '#40916C',
    description: 'Permite leitura da execução real do salão.'
  },
  afo: { 
    title: 'AFO', 
    parent: 'Gestão',
    parentPath: '/gestao',
    icon: FileText,
    color: '#95D5B2',
    description: 'Traduz a operação em fechamento gerencial.'
  },
  comercial: { 
    title: 'Comercial', 
    parent: 'Home',
    parentPath: '/',
    icon: HardDrives,
    color: '#71717A',
    description: 'Gerencie leads, campanhas, relacionamento e recorrência.'
  },
  inteligencia: { 
    title: 'Inteligência', 
    parent: 'Home',
    parentPath: '/',
    icon: HardDrives,
    color: '#71717A',
    description: 'Acesse ferramentas para crescer com método e direção.'
  },
  academy: { 
    title: 'Academy', 
    parent: 'Home',
    parentPath: '/',
    icon: HardDrives,
    color: '#71717A',
    description: 'Aulas, formação e conteúdos premium.'
  }
};

export const ModulePlaceholder = () => {
  const navigate = useNavigate();
  const { moduleId } = useParams();
  
  const module = moduleInfo[moduleId] || { 
    title: 'Módulo', 
    parent: 'Home', 
    parentPath: '/',
    icon: HardDrives,
    color: '#71717A',
    description: 'Módulo em desenvolvimento.'
  };
  
  const Icon = module.icon;

  const handleBack = () => {
    navigate(module.parentPath);
  };

  return (
    <div className="min-h-screen bg-[#F7F6F4]" data-testid={`module-${moduleId}-page`}>
      <div className="salonup-container">
        {/* Header */}
        <header className="salonup-header animate-fade-in">
          <div className="salonup-brand">
            <div className="salonup-logo-mark">
              <Scissors size={22} weight="bold" />
            </div>
            <span className="salonup-logo-text">
              Salon<span>Up</span>
            </span>
          </div>
          
          <button 
            onClick={handleBack}
            data-testid="btn-back"
            className="salonup-btn-back"
          >
            <ArrowLeft size={18} weight="bold" />
            <span>Voltar para {module.parent}</span>
          </button>
        </header>

        {/* Breadcrumb */}
        <div className="mb-6 animate-fade-in opacity-0 delay-100" style={{ animationFillMode: 'forwards' }}>
          <p className="salonup-text-xs">
            <span 
              className="cursor-pointer hover:text-[#1B4332] transition-colors"
              onClick={() => navigate('/')}
            >
              Home
            </span>
            <span className="mx-2">·</span>
            {module.parent !== 'Home' && (
              <>
                <span 
                  className="cursor-pointer hover:text-[#1B4332] transition-colors"
                  onClick={() => navigate(module.parentPath)}
                >
                  {module.parent}
                </span>
                <span className="mx-2">·</span>
              </>
            )}
            <span className="text-[#18181B] font-medium">{module.title}</span>
          </p>
        </div>

        {/* Title */}
        <section className="mb-10 md:mb-12 animate-fade-in-up opacity-0 delay-150" style={{ animationFillMode: 'forwards' }}>
          <div className="flex items-center gap-4 mb-3">
            <div 
              className="salonup-icon-wrapper"
              style={{ backgroundColor: `${module.color}15` }}
            >
              <Icon size={26} weight="regular" style={{ color: module.color }} />
            </div>
            <div>
              <h1 className="salonup-heading-lg">
                {module.title}
              </h1>
              <p className="salonup-text-sm mt-1">
                {module.description}
              </p>
            </div>
          </div>
        </section>

        {/* Placeholder Content */}
        <div className="animate-fade-in-up opacity-0 delay-200" style={{ animationFillMode: 'forwards' }}>
          <div className="salonup-card p-10 md:p-14 text-center max-w-xl mx-auto">
            <div className="flex flex-col items-center">
              <div 
                className="w-20 h-20 rounded-2xl flex items-center justify-center mb-6"
                style={{ backgroundColor: `${module.color}10` }}
              >
                <HardDrives size={36} weight="light" style={{ color: module.color }} />
              </div>
              
              <h2 className="salonup-heading-md mb-3">
                Módulo em desenvolvimento
              </h2>
              <p className="salonup-text-body max-w-sm">
                Estamos trabalhando para trazer as funcionalidades de <strong>{module.title.toLowerCase()}</strong> em breve. Fique atento às atualizações.
              </p>
              
              <div className="mt-8 flex items-center gap-2 text-[#71717A]">
                <Circle size={8} weight="fill" className="text-amber-500 animate-pulse-soft" />
                <span className="salonup-text-xs font-medium">Em construção</span>
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <footer className="salonup-footer animate-fade-in opacity-0" style={{ animationDelay: '500ms', animationFillMode: 'forwards' }}>
          <p className="salonup-text-xs">
            SalonUp — O sistema operacional do salão moderno
          </p>
        </footer>
      </div>
    </div>
  );
};

export default ModulePlaceholder;
